// @ts-expect-error pure js
import useAuthenticatedAxios from "./use-authenticated-axios";
import type { CrgBulkSummary } from "../models/crg";

export default function useCrg() {
  const axios = useAuthenticatedAxios();

  async function genererCrgs(
    idsProfileBailleur: number[],
    month: string,
    sendMail: boolean,
  ): Promise<CrgBulkSummary> {
    const response = await axios.post("/profiles/crg", {
      ids_profile_bailleur: idsProfileBailleur,
      month,
      send_mail: sendMail,
    });
    return response.data as CrgBulkSummary;
  }

  return { genererCrgs };
}
